export class ResetPasswordResult {
  newPassword: string | undefined;
  authToken: string | undefined;
  refreshToken: string | undefined;
  appId?: number | undefined;
}
